export default function ({ store, route, $log }) {
  /**
   * On first page load
   * - Pull email from query param
   */
  if (!process.server) return
  const logger = $log.create('Email MW')
  logger.debug('Start')

  // Try to get email from emailAd query parameter
  let email = route.query.emailAd

  // Try to get email from _ke query parameter
  if (!email && route.query._ke) {
    try {
      email = JSON.parse(Buffer.from(route.query._ke, 'base64').toString()).kl_email
    } catch (error) {
      logger.error(error)
      process.sentry.captureException(error)
    }
  }

  // Store the email if we've got it
  if (email) store.commit('store/SET_EMAIL', email)
  logger.debug('Finish')
}